﻿export const dataAlpha = {
  'MONDAY AUGUST 26': [
    {
      'Event Name': 'Check in & meet your F!rosh group',
      'Start Time': '7:30:00 a1/p1',
      'End Time': '8:30:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'Matriculation',
      'Event Description':
        'Our kickoff the frosh week, and introduction to all things SKULE™. We all gather in to Convocation Hall',
      'Start Time': '8:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'D!YE STATION',
      'Event Description':
        'When I say purple you say purple! Where F!rosh and Leedurs alike dye their bodies (or parts thereof) purple. The colour purple represents great significance in the traditions of engineering schools across Canada.',
      'Start Time': '11:00:00 a1/p1',
      'End Time': '11:40:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '11:40:00 a1/p1',
      'End Time': '12:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '12:30:00 a1/p1',
      'End Time': '13:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '13:30:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'DOWNTOWN WALKAROUND',
      'Event Description':
        'Join us for a lovely tour of Toronto’s downtown with 1000 of your newest friends and classmates',
      'Start Time': '15:00:00 a1/p1',
      'End Time': '18:00:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'UNWIND NIGHT',
      'Event Location': 'GB303',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'TUESDAY AUGUST 27': [
    {
      'Event Name': 'MEET WITH YOUR GROUP',
      'Event Location': 'Front Campus',
      'Start Time': '8:15:00 a1/p1',
      'End Time': '8:45:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'CONSENT WORKSHOP',
      'Start Time': '9:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '11:00:00 a1/p1',
      'End Time': '11:20:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '11:20:00 a1/p1',
      'End Time': '12:20:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '12:20:00 a1/p1',
      'End Time': '13:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'ACADEMIC SUCCESS SEMINAR',
      'Event Description':
        "Learn from some of your amazing new TA's about all the strategies you need to know for success here at UofT Engineering!",
      'Start Time': '13:30:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'BUILD BATTLE',
      'Event Description':
        "Your first of many design challenges at UofT Engineering, except its probably the one of the coolest ones you do! Work with your frosh group to tackle your piece of the puzzle for this year's unique design challenge, coming together to build something truly amazing as a 2T8 class!",
      'Start Time': '15:00:00 a1/p1',
      'End Time': '16:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '16:30:00 a1/p1',
      'End Time': '18:00:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'CHEER OFF',
      'Start Time': '18:00:00 a1/p1',
      'End Time': '18:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'TOTES & TRIVIA',
      'Event Location': 'GB303',
      'Start Time': '7:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'WEDNESDAY AUGUST 28': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'SKULE™ HUNT',
      'Event Description':
        'SKULE™ HUNT: The longest items list you’ve ever seen. Join us for a full fledged scavenger hunt all over the city of Toronto!',
      'Start Time': '5:00 PM',
      'End Time': '11:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'THURSDAY AUGUST 29': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'CLUBS FAIR',
      'Event Location': 'Bahen Lobby',
      'Event Description':
        'Interested in joining a club, intramural sport or getting involved with the Engineering Society (EngSoc)? Attend the Engineering Clubs Fair to learn more about the 100+ ways you can get involved.</a>.',
      'Start Time': '11:00 AM',
      'End Time': '2:00 PM',
      Color: 'yellow',
    },
    {
      'Event Name': 'COMMON ROOM GAME NIGHT',
      'Event Description':
        "Sign up for game night <a href='https://docs.google.com/forms/d/e/1FAIpQLSfDGU1ejsC8bIwtHwCWC0YiEIULjcpsCm4yJ3x2cRvwCBIA7Q/viewform'>here</a>!",
      'Event Location': 'MB225',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'FRIDAY AUGUST 30': [
    {
      'Event Name': 'F!ROSH OLYMPIKS',
      'Start Time': '10:00 AM',
      'End Time': '5:00 PM',
      Color: 'purple',
    },
    {
      'Event Name': 'SKULE’S GOT TALENT',
      'Event Description':
        "Sign up for the talent show <a href='https://docs.google.com/forms/d/e/1FAIpQLSf4O3uIvwVlFQ-kuobHp_OUWwPA9f7kfUvzSWhrBMv_jQqgZg/viewform'>here</a>!",
      'Event Location': 'GB Front Steps',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
};
export const dataBeta = {
  'MONDAY AUGUST 26': [
    {
      'Event Name': 'CHECK-IN & MEET YOUR F!ROSH GROUP',
      'Start Time': '7:30:00 a1/p1',
      'End Time': '8:30:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'MATRICULATION',
      'Event Description':
        'Our kickoff the frosh week, and introduction to all things SKULE™. We all gather in to Convocation Hall',
      'Start Time': '8:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '11:00:00 a1/p1',
      'End Time': '11:20:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '11:20:00 a1/p1',
      'End Time': '12:20:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '12:20:00 a1/p1',
      'End Time': '12:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'D!YE STATION',
      'Event Description':
        'When I say purple you say purple! Where F!rosh and Leedurs alike dye their bodies (or parts thereof) purple. The colour purple represents great significance in the traditions of engineering schools across Canada.',
      'Start Time': '12:30:00 a1/p1',
      'End Time': '13:00:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '13:00:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'DOWNTOWN WALKAROUND',
      'Event Description':
        'Join us for a lovely tour of Toronto’s downtown with 1000 of your newest friends and classmates',
      'Start Time': '15:00:00 a1/p1',
      'End Time': '18:00:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'UNWIND NIGHT',
      'Event Location': 'GB303',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'TUESDAY AUGUST 27': [
    {
      'Event Name': 'MEET WITH YOUR GROUP',
      'Event Location': 'Front Campus',
      'Start Time': '8:15:00 a1/p1',
      'End Time': '8:45:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'CONSENT WORKSHOP',
      'Start Time': '9:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '11:00:00 a1/p1',
      'End Time': '11:20:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '11:20:00 a1/p1',
      'End Time': '12:20:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '12:20:00 a1/p1',
      'End Time': '13:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'ACADEMIC SUCCESS SEMINAR',
      'Event Description':
        "Learn from some of your amazing new TA's about all the strategies you need to know for success here at UofT Engineering!",
      'Start Time': '13:30:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'BUILD BATTLE',
      'Event Description':
        "Your first of many design challenges at UofT Engineering, except its probably the one of the coolest ones you do! Work with your frosh group to tackle your piece of the puzzle for this year's unique design challenge, coming together to build something truly amazing as a 2T8 class!",
      'Start Time': '15:00:00 a1/p1',
      'End Time': '16:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '16:30:00 a1/p1',
      'End Time': '18:00:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'CHEER OFF',
      'Start Time': '18:00:00 a1/p1',
      'End Time': '18:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'TOTES & TRIVIA',
      'Event Location': 'GB303',
      'Start Time': '7:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'WEDNESDAY AUGUST 28': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'SKULE™ HUNT',
      'Event Description':
        'SKULE™ HUNT: The longest items list you’ve ever seen. Join us for a full fledged scavenger hunt all over the city of Toronto!',
      'Start Time': '5:00 PM',
      'End Time': '11:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'THURSDAY AUGUST 29': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'CLUBS FAIR',
      'Event Location': 'Bahen Lobby',
      'Event Description':
        'Interested in joining a club, intramural sport or getting involved with the Engineering Society (EngSoc)? Attend the Engineering Clubs Fair to learn more about the 100+ ways you can get involved.</a>.',
      'Start Time': '11:00 AM',
      'End Time': '2:00 PM',
      Color: 'yellow',
    },
    {
      'Event Name': 'COMMON ROOM GAME NIGHT',
      'Event Description':
        "Sign up for game night <a href='https://docs.google.com/forms/d/e/1FAIpQLSfDGU1ejsC8bIwtHwCWC0YiEIULjcpsCm4yJ3x2cRvwCBIA7Q/viewform'>here</a>!",
      'Event Location': 'MB225',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'FRIDAY AUGUST 30': [
    {
      'Event Name': 'F!ROSH OLYMPIKS',
      'Start Time': '10:00 AM',
      'End Time': '5:00 PM',
      Color: 'purple',
    },
    {
      'Event Name': 'SKULE’S GOT TALENT',
      'Event Description':
        "Sign up for the talent show <a href='https://docs.google.com/forms/d/e/1FAIpQLSf4O3uIvwVlFQ-kuobHp_OUWwPA9f7kfUvzSWhrBMv_jQqgZg/viewform'>here</a>!",
      'Event Location': 'GB Front Steps',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
};
export const dataChi = {
  'MONDAY AUGUST 26': [
    {
      'Event Name': 'CHECK-IN & MEET YOUR F!ROSH GROUP',
      'Start Time': '7:30:00 a1/p1',
      'End Time': '8:30:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'MATRICULATION',
      'Event Description':
        'Our kickoff the frosh week, and introduction to all things SKULE™. We all gather in to Convocation Hall',
      'Start Time': '8:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '11:00:00 a1/p1',
      'End Time': '12:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '12:30:00 a1/p1',
      'End Time': '13:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '13:30:00 a1/p1',
      'End Time': '13:40:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'D!YE STATION',
      'Event Description':
        'When I say purple you say purple! Where F!rosh and Leedurs alike dye their bodies (or parts thereof) purple. The colour purple represents great significance in the traditions of engineering schools across Canada.',
      'Start Time': '13:40:00 a1/p1',
      'End Time': '14:10:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '14:10:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'DOWNTOWN WALKAROUND',
      'Event Description':
        'Join us for a lovely tour of Toronto’s downtown with 1000 of your newest friends and classmates',
      'Start Time': '15:00:00 a1/p1',
      'End Time': '18:00:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'UNWIND NIGHT',
      'Event Location': 'GB303',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'TUESDAY AUGUST 27': [
    {
      'Event Name': 'MEET WITH YOUR GROUP',
      'Event Location': 'Front Campus',
      'Start Time': '8:15:00 a1/p1',
      'End Time': '8:45:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'CONSENT WORKSHOP',
      'Start Time': '9:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'BUILD BATTLE',
      'Event Description':
        "Your first of many design challenges at UofT Engineering, except its probably the one of the coolest ones you do! Work with your frosh group to tackle your piece of the puzzle for this year's unique design challenge, coming together to build something truly amazing as a 2T8 class!",
      'Start Time': '11:00:00 a1/p1',
      'End Time': '12:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '12:30:00 a1/p1',
      'End Time': '13:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'ACADEMIC SUCCESS SEMINAR',
      'Event Description':
        "Learn from some of your amazing new TA's about all the strategies you need to know for success here at UofT Engineering!",
      'Start Time': '13:30:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '15:00:00 a1/p1',
      'End Time': '18:00:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'CHEER OFF',
      'Start Time': '18:00:00 a1/p1',
      'End Time': '18:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'TOTES & TRIVIA',
      'Event Location': 'GB303',
      'Start Time': '7:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'WEDNESDAY AUGUST 28': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'SKULE™ HUNT',
      'Event Description':
        'SKULE™ HUNT: The longest items list you’ve ever seen. Join us for a full fledged scavenger hunt all over the city of Toronto!',
      'Start Time': '5:00 PM',
      'End Time': '11:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'THURSDAY AUGUST 29': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'CLUBS FAIR',
      'Event Location': 'Bahen Lobby',
      'Event Description':
        'Interested in joining a club, intramural sport or getting involved with the Engineering Society (EngSoc)? Attend the Engineering Clubs Fair to learn more about the 100+ ways you can get involved.</a>.',
      'Start Time': '11:00 AM',
      'End Time': '2:00 PM',
      Color: 'yellow',
    },
    {
      'Event Name': 'COMMON ROOM GAME NIGHT',
      'Event Description':
        "Sign up for game night <a href='https://docs.google.com/forms/d/e/1FAIpQLSfDGU1ejsC8bIwtHwCWC0YiEIULjcpsCm4yJ3x2cRvwCBIA7Q/viewform'>here</a>!",
      'Event Location': 'MB225',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'FRIDAY AUGUST 30': [
    {
      'Event Name': 'F!ROSH OLYMPIKS',
      'Start Time': '10:00 AM',
      'End Time': '5:00 PM',
      Color: 'purple',
    },
    {
      'Event Name': 'SKULE’S GOT TALENT',
      'Event Description':
        "Sign up for the talent show <a href='https://docs.google.com/forms/d/e/1FAIpQLSf4O3uIvwVlFQ-kuobHp_OUWwPA9f7kfUvzSWhrBMv_jQqgZg/viewform'>here</a>!",
      'Event Location': 'GB Front Steps',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
};
export const dataDelta = {
  'MONDAY AUGUST 26': [
    {
      'Event Name': 'CHECK-IN & MEET YOUR F!ROSH GROUP',
      'Start Time': '7:30:00 a1/p1',
      'End Time': '8:30:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'MATRICULATION',
      'Event Description':
        'Our kickoff the frosh week, and introduction to all things SKULE™. We all gather in to Convocation Hall',
      'Start Time': '8:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '11:00:00 a1/p1',
      'End Time': '11:20:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '11:20:00 a1/p1',
      'End Time': '12:20:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '12:20:00 a1/p1',
      'End Time': '14:10:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'D!YE STATION',
      'Event Description':
        'When I say purple you say purple! Where F!rosh and Leedurs alike dye their bodies (or parts thereof) purple. The colour purple represents great significance in the traditions of engineering schools across Canada.',
      'Start Time': '14:10:00 a1/p1',
      'End Time': '14:40:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '14:40:00 a1/p1',
      'End Time': '16:00:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'DOWNTOWN WALKAROUND',
      'Event Description':
        'Join us for a lovely tour of Toronto’s downtown with 1000 of your newest friends and classmates',
      'Start Time': '15:00:00 a1/p1',
      'End Time': '18:00:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'UNWIND NIGHT',
      'Event Location': 'GB303',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'TUESDAY AUGUST 27': [
    {
      'Event Name': 'MEET WITH YOUR GROUP',
      'Event Location': 'Front Campus',
      'Start Time': '8:15:00 a1/p1',
      'End Time': '8:45:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'CONSENT WORKSHOP',
      'Start Time': '9:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'BUILD BATTLE',
      'Event Description':
        "Your first of many design challenges at UofT Engineering, except its probably the one of the coolest ones you do! Work with your frosh group to tackle your piece of the puzzle for this year's unique design challenge, coming together to build something truly amazing as a 2T8 class!",
      'Start Time': '11:00:00 a1/p1',
      'End Time': '12:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '12:30:00 a1/p1',
      'End Time': '13:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'ACADEMIC SUCCESS SEMINAR',
      'Event Description':
        "Learn from some of your amazing new TA's about all the strategies you need to know for success here at UofT Engineering!",
      'Start Time': '13:30:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '15:00:00 a1/p1',
      'End Time': '18:00:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'CHEER OFF',
      'Start Time': '18:00:00 a1/p1',
      'End Time': '18:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'TOTES & TRIVIA',
      'Event Location': 'GB303',
      'Start Time': '7:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'WEDNESDAY AUGUST 28': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'SKULE™ HUNT',
      'Event Description':
        'SKULE™ HUNT: The longest items list you’ve ever seen. Join us for a full fledged scavenger hunt all over the city of Toronto!',
      'Start Time': '5:00 PM',
      'End Time': '11:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'THURSDAY AUGUST 29': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'CLUBS FAIR',
      'Event Location': 'Bahen Lobby',
      'Event Description':
        'Interested in joining a club, intramural sport or getting involved with the Engineering Society (EngSoc)? Attend the Engineering Clubs Fair to learn more about the 100+ ways you can get involved.</a>.',
      'Start Time': '11:00 AM',
      'End Time': '2:00 PM',
      Color: 'yellow',
    },
    {
      'Event Name': 'COMMON ROOM GAME NIGHT',
      'Event Description':
        "Sign up for game night <a href='https://docs.google.com/forms/d/e/1FAIpQLSfDGU1ejsC8bIwtHwCWC0YiEIULjcpsCm4yJ3x2cRvwCBIA7Q/viewform'>here</a>!",
      'Event Location': 'MB225',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'FRIDAY AUGUST 30': [
    {
      'Event Name': 'F!ROSH OLYMPIKS',
      'Start Time': '10:00 AM',
      'End Time': '5:00 PM',
      Color: 'purple',
    },
    {
      'Event Name': 'SKULE’S GOT TALENT',
      'Event Description':
        "Sign up for the talent show <a href='https://docs.google.com/forms/d/e/1FAIpQLSf4O3uIvwVlFQ-kuobHp_OUWwPA9f7kfUvzSWhrBMv_jQqgZg/viewform'>here</a>!",
      'Event Location': 'GB Front Steps',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
};
export const dataGamma = {
  'MONDAY AUGUST 26': [
    {
      'Event Name': 'CHECK-IN & MEET YOUR F!ROSH GROUP',
      'Start Time': '7:30:00 a1/p1',
      'End Time': '8:30:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'MATRICULATION',
      'Event Description':
        'Our kickoff the frosh week, and introduction to all things SKULE™. We all gather in to Convocation Hall',
      'Start Time': '8:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '11:00:00 a1/p1',
      'End Time': '11:20:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '11:20:00 a1/p1',
      'End Time': '12:20:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'D!YE STATION',
      'Event Description':
        'When I say purple you say purple! Where F!rosh and Leedurs alike dye their bodies (or parts thereof) purple. The colour purple represents great significance in the traditions of engineering schools across Canada.',
      'Start Time': '12:20:00 a1/p1',
      'End Time': '13:00:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '13:00:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'DOWNTOWN WALKAROUND',
      'Event Description':
        'Join us for a lovely tour of Toronto’s downtown with 1000 of your newest friends and classmates',
      'Start Time': '15:00:00 a1/p1',
      'End Time': '18:00:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'UNWIND NIGHT',
      'Event Location': 'GB303',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'TUESDAY AUGUST 27': [
    {
      'Event Name': 'MEET WITH YOUR GROUP',
      'Event Location': 'Front Campus',
      'Start Time': '8:15:00 a1/p1',
      'End Time': '8:45:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'CONSENT WORKSHOP',
      'Start Time': '9:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'BUILD BATTLE',
      'Event Description':
        "Your first of many design challenges at UofT Engineering, except its probably the one of the coolest ones you do! Work with your frosh group to tackle your piece of the puzzle for this year's unique design challenge, coming together to build something truly amazing as a 2T8 class!",
      'Start Time': '11:00:00 a1/p1',
      'End Time': '12:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '12:30:00 a1/p1',
      'End Time': '13:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'ACADEMIC SUCCESS SEMINAR',
      'Event Description':
        "Learn from some of your amazing new TA's about all the strategies you need to know for success here at UofT Engineering!",
      'Start Time': '13:30:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '15:00:00 a1/p1',
      'End Time': '18:00:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'CHEER OFF',
      'Start Time': '18:00:00 a1/p1',
      'End Time': '18:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'TOTES & TRIVIA',
      'Event Location': 'GB303',
      'Start Time': '7:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'WEDNESDAY AUGUST 28': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'SKULE™ HUNT',
      'Event Description':
        'SKULE™ HUNT: The longest items list you’ve ever seen. Join us for a full fledged scavenger hunt all over the city of Toronto!',
      'Start Time': '5:00 PM',
      'End Time': '11:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'THURSDAY AUGUST 29': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'CLUBS FAIR',
      'Event Location': 'Bahen Lobby',
      'Event Description':
        'Interested in joining a club, intramural sport or getting involved with the Engineering Society (EngSoc)? Attend the Engineering Clubs Fair to learn more about the 100+ ways you can get involved.</a>.',
      'Start Time': '11:00 AM',
      'End Time': '2:00 PM',
      Color: 'yellow',
    },
    {
      'Event Name': 'COMMON ROOM GAME NIGHT',
      'Event Description':
        "Sign up for game night <a href='https://docs.google.com/forms/d/e/1FAIpQLSfDGU1ejsC8bIwtHwCWC0YiEIULjcpsCm4yJ3x2cRvwCBIA7Q/viewform'>here</a>!",
      'Event Location': 'MB225',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'FRIDAY AUGUST 30': [
    {
      'Event Name': 'F!ROSH OLYMPIKS',
      'Start Time': '10:00 AM',
      'End Time': '5:00 PM',
      Color: 'purple',
    },
    {
      'Event Name': 'SKULE’S GOT TALENT',
      'Event Description':
        "Sign up for the talent show <a href='https://docs.google.com/forms/d/e/1FAIpQLSf4O3uIvwVlFQ-kuobHp_OUWwPA9f7kfUvzSWhrBMv_jQqgZg/viewform'>here</a>!",
      'Event Location': 'GB Front Steps',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
};
export const dataIota = {
  'MONDAY AUGUST 26': [
    {
      'Event Name': 'CHECK-IN & MEET YOUR F!ROSH GROUP',
      'Start Time': '7:30:00 a1/p1',
      'End Time': '8:30:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'MATRICULATION',
      'Event Description':
        'Our kickoff the frosh week, and introduction to all things SKULE™. We all gather in to Convocation Hall',
      'Start Time': '8:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '11:00:00 a1/p1',
      'End Time': '11:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'D!YE STATION',
      'Event Description':
        'When I say purple you say purple! Where F!rosh and Leedurs alike dye their bodies (or parts thereof) purple. The colour purple represents great significance in the traditions of engineering schools across Canada.',
      'Start Time': '11:30:00 a1/p1',
      'End Time': '12:10:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '12:10:00 a1/p1',
      'End Time': '12:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '12:30:00 a1/p1',
      'End Time': '13:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '13:30:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'DOWNTOWN WALKAROUND',
      'Event Description':
        'Join us for a lovely tour of Toronto’s downtown with 1000 of your newest friends and classmates',
      'Start Time': '15:00:00 a1/p1',
      'End Time': '18:00:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'UNWIND NIGHT',
      'Event Location': 'GB303',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'TUESDAY AUGUST 27': [
    {
      'Event Name': 'MEET WITH YOUR GROUP',
      'Event Location': 'Front Campus',
      'Start Time': '8:15:00 a1/p1',
      'End Time': '8:45:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'CONSENT WORKSHOP',
      'Start Time': '9:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '11:00:00 a1/p1',
      'End Time': '11:20:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '11:20:00 a1/p1',
      'End Time': '12:20:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '12:20:00 a1/p1',
      'End Time': '13:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'ACADEMIC SUCCESS SEMINAR',
      'Event Description':
        "Learn from some of your amazing new TA's about all the strategies you need to know for success here at UofT Engineering!",
      'Start Time': '13:30:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'BUILD BATTLE',
      'Event Description':
        "Your first of many design challenges at UofT Engineering, except its probably the one of the coolest ones you do! Work with your frosh group to tackle your piece of the puzzle for this year's unique design challenge, coming together to build something truly amazing as a 2T8 class!",
      'Start Time': '15:00:00 a1/p1',
      'End Time': '16:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '16:30:00 a1/p1',
      'End Time': '18:00:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'CHEER OFF',
      'Start Time': '18:00:00 a1/p1',
      'End Time': '18:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'TOTES & TRIVIA',
      'Event Location': 'GB303',
      'Start Time': '7:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'WEDNESDAY AUGUST 28': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'SKULE™ HUNT',
      'Event Description':
        'SKULE™ HUNT: The longest items list you’ve ever seen. Join us for a full fledged scavenger hunt all over the city of Toronto!',
      'Start Time': '5:00 PM',
      'End Time': '11:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'THURSDAY AUGUST 29': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'CLUBS FAIR',
      'Event Location': 'Bahen Lobby',
      'Event Description':
        'Interested in joining a club, intramural sport or getting involved with the Engineering Society (EngSoc)? Attend the Engineering Clubs Fair to learn more about the 100+ ways you can get involved.</a>.',
      'Start Time': '11:00 AM',
      'End Time': '2:00 PM',
      Color: 'yellow',
    },
    {
      'Event Name': 'COMMON ROOM GAME NIGHT',
      'Event Description':
        "Sign up for game night <a href='https://docs.google.com/forms/d/e/1FAIpQLSfDGU1ejsC8bIwtHwCWC0YiEIULjcpsCm4yJ3x2cRvwCBIA7Q/viewform'>here</a>!",
      'Event Location': 'MB225',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'FRIDAY AUGUST 30': [
    {
      'Event Name': 'F!ROSH OLYMPIKS',
      'Start Time': '10:00 AM',
      'End Time': '5:00 PM',
      Color: 'purple',
    },
    {
      'Event Name': 'SKULE’S GOT TALENT',
      'Event Description':
        "Sign up for the talent show <a href='https://docs.google.com/forms/d/e/1FAIpQLSf4O3uIvwVlFQ-kuobHp_OUWwPA9f7kfUvzSWhrBMv_jQqgZg/viewform'>here</a>!",
      'Event Location': 'GB Front Steps',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
};
export const dataKappa = {
  'MONDAY AUGUST 26': [
    {
      'Event Name': 'CHECK-IN & MEET YOUR F!ROSH GROUP',
      'Start Time': '7:30:00 a1/p1',
      'End Time': '8:30:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'MATRICULATION',
      'Event Description':
        'Our kickoff the frosh week, and introduction to all things SKULE™. We all gather in to Convocation Hall',
      'Start Time': '8:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'D!YE STATION',
      'Event Description':
        'When I say purple you say purple! Where F!rosh and Leedurs alike dye their bodies (or parts thereof) purple. The colour purple represents great significance in the traditions of engineering schools across Canada.',
      'Start Time': '11:00:00 a1/p1',
      'End Time': '11:30:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '11:30:00 a1/p1',
      'End Time': '12:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '12:30:00 a1/p1',
      'End Time': '13:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '13:30:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'DOWNTOWN WALKAROUND',
      'Event Description':
        'Join us for a lovely tour of Toronto’s downtown with 1000 of your newest friends and classmates',
      'Start Time': '15:00:00 a1/p1',
      'End Time': '18:00:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'UNWIND NIGHT',
      'Event Location': 'GB303',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'TUESDAY AUGUST 27': [
    {
      'Event Name': 'MEET WITH YOUR GROUP',
      'Event Location': 'Front Campus',
      'Start Time': '8:15:00 a1/p1',
      'End Time': '8:45:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'CONSENT WORKSHOP',
      'Start Time': '9:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '11:00:00 a1/p1',
      'End Time': '11:20:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '11:20:00 a1/p1',
      'End Time': '12:20:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '12:20:00 a1/p1',
      'End Time': '13:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'ACADEMIC SUCCESS SEMINAR',
      'Event Description':
        "Learn from some of your amazing new TA's about all the strategies you need to know for success here at UofT Engineering!",
      'Start Time': '13:30:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '15:00:00 a1/p1',
      'End Time': '16:20:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'BUILD BATTLE',
      'Event Description':
        "Your first of many design challenges at UofT Engineering, except its probably the one of the coolest ones you do! Work with your frosh group to tackle your piece of the puzzle for this year's unique design challenge, coming together to build something truly amazing as a 2T8 class!",
      'Start Time': '16:20:00 a1/p1',
      'End Time': '17:50:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'CHEER OFF',
      'Start Time': '18:00:00 a1/p1',
      'End Time': '18:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'TOTES & TRIVIA',
      'Event Location': 'GB303',
      'Start Time': '7:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'WEDNESDAY AUGUST 28': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'SKULE™ HUNT',
      'Event Description':
        'SKULE™ HUNT: The longest items list you’ve ever seen. Join us for a full fledged scavenger hunt all over the city of Toronto!',
      'Start Time': '5:00 PM',
      'End Time': '11:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'THURSDAY AUGUST 29': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'CLUBS FAIR',
      'Event Location': 'Bahen Lobby',
      'Event Description':
        'Interested in joining a club, intramural sport or getting involved with the Engineering Society (EngSoc)? Attend the Engineering Clubs Fair to learn more about the 100+ ways you can get involved.</a>.',
      'Start Time': '11:00 AM',
      'End Time': '2:00 PM',
      Color: 'yellow',
    },
    {
      'Event Name': 'COMMON ROOM GAME NIGHT',
      'Event Description':
        "Sign up for game night <a href='https://docs.google.com/forms/d/e/1FAIpQLSfDGU1ejsC8bIwtHwCWC0YiEIULjcpsCm4yJ3x2cRvwCBIA7Q/viewform'>here</a>!",
      'Event Location': 'MB225',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'FRIDAY AUGUST 30': [
    {
      'Event Name': 'F!ROSH OLYMPIKS',
      'Start Time': '10:00 AM',
      'End Time': '5:00 PM',
      Color: 'purple',
    },
    {
      'Event Name': 'SKULE’S GOT TALENT',
      'Event Description':
        "Sign up for the talent show <a href='https://docs.google.com/forms/d/e/1FAIpQLSf4O3uIvwVlFQ-kuobHp_OUWwPA9f7kfUvzSWhrBMv_jQqgZg/viewform'>here</a>!",
      'Event Location': 'GB Front Steps',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
};
export const dataLambda = {
  'MONDAY AUGUST 26': [
    {
      'Event Name': 'CHECK-IN & MEET YOUR F!ROSH GROUP',
      'Start Time': '7:30:00 a1/p1',
      'End Time': '8:30:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'MATRICULATION',
      'Event Description':
        'Our kickoff the frosh week, and introduction to all things SKULE™. We all gather in to Convocation Hall',
      'Start Time': '8:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '11:00:00 a1/p1',
      'End Time': '11:20:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '11:20:00 a1/p1',
      'End Time': '12:20:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '12:20:00 a1/p1',
      'End Time': '13:10:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'D!YE STATION',
      'Event Description':
        'When I say purple you say purple! Where F!rosh and Leedurs alike dye their bodies (or parts thereof) purple. The colour purple represents great significance in the traditions of engineering schools across Canada.',
      'Start Time': '13:10:00 a1/p1',
      'End Time': '13:40:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '13:40:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'DOWNTOWN WALKAROUND',
      'Event Description':
        'Join us for a lovely tour of Toronto’s downtown with 1000 of your newest friends and classmates',
      'Start Time': '15:00:00 a1/p1',
      'End Time': '18:00:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'UNWIND NIGHT',
      'Event Location': 'GB303',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'TUESDAY AUGUST 27': [
    {
      'Event Name': 'MEET WITH YOUR GROUP',
      'Event Location': 'Front Campus',
      'Start Time': '8:15:00 a1/p1',
      'End Time': '8:45:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'CONSENT WORKSHOP',
      'Start Time': '9:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '11:00:00 a1/p1',
      'End Time': '11:20:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '11:20:00 a1/p1',
      'End Time': '12:20:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '12:20:00 a1/p1',
      'End Time': '13:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'ACADEMIC SUCCESS SEMINAR',
      'Event Description':
        "Learn from some of your amazing new TA's about all the strategies you need to know for success here at UofT Engineering!",
      'Start Time': '13:30:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '15:00:00 a1/p1',
      'End Time': '16:20:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'BUILD BATTLE',
      'Event Description':
        "Your first of many design challenges at UofT Engineering, except its probably the one of the coolest ones you do! Work with your frosh group to tackle your piece of the puzzle for this year's unique design challenge, coming together to build something truly amazing as a 2T8 class!",
      'Start Time': '16:20:00 a1/p1',
      'End Time': '17:50:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'CHEER OFF',
      'Start Time': '18:00:00 a1/p1',
      'End Time': '18:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'TOTES & TRIVIA',
      'Event Location': 'GB303',
      'Start Time': '7:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'WEDNESDAY AUGUST 28': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'SKULE™ HUNT',
      'Event Description':
        'SKULE™ HUNT: The longest items list you’ve ever seen. Join us for a full fledged scavenger hunt all over the city of Toronto!',
      'Start Time': '5:00 PM',
      'End Time': '11:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'THURSDAY AUGUST 29': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'CLUBS FAIR',
      'Event Location': 'Bahen Lobby',
      'Event Description':
        'Interested in joining a club, intramural sport or getting involved with the Engineering Society (EngSoc)? Attend the Engineering Clubs Fair to learn more about the 100+ ways you can get involved.</a>.',
      'Start Time': '11:00 AM',
      'End Time': '2:00 PM',
      Color: 'yellow',
    },
    {
      'Event Name': 'COMMON ROOM GAME NIGHT',
      'Event Description':
        "Sign up for game night <a href='https://docs.google.com/forms/d/e/1FAIpQLSfDGU1ejsC8bIwtHwCWC0YiEIULjcpsCm4yJ3x2cRvwCBIA7Q/viewform'>here</a>!",
      'Event Location': 'MB225',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'FRIDAY AUGUST 30': [
    {
      'Event Name': 'F!ROSH OLYMPIKS',
      'Start Time': '10:00 AM',
      'End Time': '5:00 PM',
      Color: 'purple',
    },
    {
      'Event Name': 'SKULE’S GOT TALENT',
      'Event Description':
        "Sign up for the talent show <a href='https://docs.google.com/forms/d/e/1FAIpQLSf4O3uIvwVlFQ-kuobHp_OUWwPA9f7kfUvzSWhrBMv_jQqgZg/viewform'>here</a>!",
      'Event Location': 'GB Front Steps',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
};
export const dataNu = {
  'MONDAY AUGUST 26': [
    {
      'Event Name': 'CHECK-IN & MEET YOUR F!ROSH GROUP',
      'Start Time': '7:30:00 a1/p1',
      'End Time': '8:30:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'MATRICULATION',
      'Event Description':
        'Our kickoff the frosh week, and introduction to all things SKULE™. We all gather in to Convocation Hall',
      'Start Time': '8:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '11:00:00 a1/p1',
      'End Time': '11:20:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '11:20:00 a1/p1',
      'End Time': '12:20:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '12:20:00 a1/p1',
      'End Time': '12:40:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'D!YE STATION',
      'Event Description':
        'When I say purple you say purple! Where F!rosh and Leedurs alike dye their bodies (or parts thereof) purple. The colour purple represents great significance in the traditions of engineering schools across Canada.',
      'Start Time': '12:40:00 a1/p1',
      'End Time': '13:10:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '13:10:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'DOWNTOWN WALKAROUND',
      'Event Description':
        'Join us for a lovely tour of Toronto’s downtown with 1000 of your newest friends and classmates',
      'Start Time': '15:00:00 a1/p1',
      'End Time': '18:00:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'UNWIND NIGHT',
      'Event Location': 'GB303',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'TUESDAY AUGUST 27': [
    {
      'Event Name': 'MEET WITH YOUR GROUP',
      'Event Location': 'Front Campus',
      'Start Time': '8:15:00 a1/p1',
      'End Time': '8:45:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'CONSENT WORKSHOP',
      'Start Time': '9:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '11:00:00 a1/p1',
      'End Time': '11:20:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '11:20:00 a1/p1',
      'End Time': '12:20:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '12:20:00 a1/p1',
      'End Time': '13:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'ACADEMIC SUCCESS SEMINAR',
      'Event Description':
        "Learn from some of your amazing new TA's about all the strategies you need to know for success here at UofT Engineering!",
      'Start Time': '13:30:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '15:00:00 a1/p1',
      'End Time': '16:20:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'BUILD BATTLE',
      'Event Description':
        "Your first of many design challenges at UofT Engineering, except its probably the one of the coolest ones you do! Work with your frosh group to tackle your piece of the puzzle for this year's unique design challenge, coming together to build something truly amazing as a 2T8 class!",
      'Start Time': '16:20:00 a1/p1',
      'End Time': '17:50:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'CHEER OFF',
      'Start Time': '18:00:00 a1/p1',
      'End Time': '18:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'TOTES & TRIVIA',
      'Event Location': 'GB303',
      'Start Time': '7:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'WEDNESDAY AUGUST 28': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'SKULE™ HUNT',
      'Event Description':
        'SKULE™ HUNT: The longest items list you’ve ever seen. Join us for a full fledged scavenger hunt all over the city of Toronto!',
      'Start Time': '5:00 PM',
      'End Time': '11:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'THURSDAY AUGUST 29': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'CLUBS FAIR',
      'Event Location': 'Bahen Lobby',
      'Event Description':
        'Interested in joining a club, intramural sport or getting involved with the Engineering Society (EngSoc)? Attend the Engineering Clubs Fair to learn more about the 100+ ways you can get involved.</a>.',
      'Start Time': '11:00 AM',
      'End Time': '2:00 PM',
      Color: 'yellow',
    },
    {
      'Event Name': 'COMMON ROOM GAME NIGHT',
      'Event Description':
        "Sign up for game night <a href='https://docs.google.com/forms/d/e/1FAIpQLSfDGU1ejsC8bIwtHwCWC0YiEIULjcpsCm4yJ3x2cRvwCBIA7Q/viewform'>here</a>!",
      'Event Location': 'MB225',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'FRIDAY AUGUST 30': [
    {
      'Event Name': 'F!ROSH OLYMPIKS',
      'Start Time': '10:00 AM',
      'End Time': '5:00 PM',
      Color: 'purple',
    },
    {
      'Event Name': 'SKULE’S GOT TALENT',
      'Event Description':
        "Sign up for the talent show <a href='https://docs.google.com/forms/d/e/1FAIpQLSf4O3uIvwVlFQ-kuobHp_OUWwPA9f7kfUvzSWhrBMv_jQqgZg/viewform'>here</a>!",
      'Event Location': 'GB Front Steps',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
};
export const dataOmega = {
  'MONDAY AUGUST 26': [
    {
      'Event Name': 'CHECK-IN & MEET YOUR F!ROSH GROUP',
      'Start Time': '7:30:00 a1/p1',
      'End Time': '8:30:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'MATRICULATION',
      'Event Description':
        'Our kickoff the frosh week, and introduction to all things SKULE™. We all gather in to Convocation Hall',
      'Start Time': '8:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '11:00:00 a1/p1',
      'End Time': '12:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '12:30:00 a1/p1',
      'End Time': '13:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'D!YE STATION',
      'Event Description':
        'When I say purple you say purple! Where F!rosh and Leedurs alike dye their bodies (or parts thereof) purple. The colour purple represents great significance in the traditions of engineering schools across Canada.',
      'Start Time': '13:30:00 a1/p1',
      'End Time': '14:00:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '14:00:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'DOWNTOWN WALKAROUND',
      'Event Description':
        'Join us for a lovely tour of Toronto’s downtown with 1000 of your newest friends and classmates',
      'Start Time': '15:00:00 a1/p1',
      'End Time': '18:00:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'UNWIND NIGHT',
      'Event Location': 'GB303',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'TUESDAY AUGUST 27': [
    {
      'Event Name': 'MEET WITH YOUR GROUP',
      'Event Location': 'Front Campus',
      'Start Time': '8:15:00 a1/p1',
      'End Time': '8:45:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'CONSENT WORKSHOP',
      'Start Time': '9:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '11:00:00 a1/p1',
      'End Time': '12:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '12:30:00 a1/p1',
      'End Time': '13:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'ACADEMIC SUCCESS SEMINAR',
      'Event Description':
        "Learn from some of your amazing new TA's about all the strategies you need to know for success here at UofT Engineering!",
      'Start Time': '13:30:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '15:00:00 a1/p1',
      'End Time': '16:10:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'BUILD BATTLE',
      'Event Description':
        "Your first of many design challenges at UofT Engineering, except its probably the one of the coolest ones you do! Work with your frosh group to tackle your piece of the puzzle for this year's unique design challenge, coming together to build something truly amazing as a 2T8 class!",
      'Start Time': '16:20:00 a1/p1',
      'End Time': '17:40:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'CHEER OFF',
      'Start Time': '18:00:00 a1/p1',
      'End Time': '18:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'TOTES & TRIVIA',
      'Event Location': 'GB303',
      'Start Time': '7:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'WEDNESDAY AUGUST 28': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'SKULE™ HUNT',
      'Event Description':
        'SKULE™ HUNT: The longest items list you’ve ever seen. Join us for a full fledged scavenger hunt all over the city of Toronto!',
      'Start Time': '5:00 PM',
      'End Time': '11:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'THURSDAY AUGUST 29': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'CLUBS FAIR',
      'Event Location': 'Bahen Lobby',
      'Event Description':
        'Interested in joining a club, intramural sport or getting involved with the Engineering Society (EngSoc)? Attend the Engineering Clubs Fair to learn more about the 100+ ways you can get involved.</a>.',
      'Start Time': '11:00 AM',
      'End Time': '2:00 PM',
      Color: 'yellow',
    },
    {
      'Event Name': 'COMMON ROOM GAME NIGHT',
      'Event Description':
        "Sign up for game night <a href='https://docs.google.com/forms/d/e/1FAIpQLSfDGU1ejsC8bIwtHwCWC0YiEIULjcpsCm4yJ3x2cRvwCBIA7Q/viewform'>here</a>!",
      'Event Location': 'MB225',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'FRIDAY AUGUST 30': [
    {
      'Event Name': 'F!ROSH OLYMPIKS',
      'Start Time': '10:00 AM',
      'End Time': '5:00 PM',
      Color: 'purple',
    },
    {
      'Event Name': 'SKULE’S GOT TALENT',
      'Event Description':
        "Sign up for the talent show <a href='https://docs.google.com/forms/d/e/1FAIpQLSf4O3uIvwVlFQ-kuobHp_OUWwPA9f7kfUvzSWhrBMv_jQqgZg/viewform'>here</a>!",
      'Event Location': 'GB Front Steps',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
};
export const dataOmicron = {
  'MONDAY AUGUST 26': [
    {
      'Event Name': 'CHECK-IN & MEET YOUR F!ROSH GROUP',
      'Start Time': '7:30:00 a1/p1',
      'End Time': '8:30:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'MATRICULATION',
      'Event Description':
        'Our kickoff the frosh week, and introduction to all things SKULE™. We all gather in to Convocation Hall',
      'Start Time': '8:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '11:00:00 a1/p1',
      'End Time': '12:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '12:30:00 a1/p1',
      'End Time': '13:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '13:30:00 a1/p1',
      'End Time': '13:50:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'D!YE STATION',
      'Event Description':
        'When I say purple you say purple! Where F!rosh and Leedurs alike dye their bodies (or parts thereof) purple. The colour purple represents great significance in the traditions of engineering schools across Canada.',
      'Start Time': '13:50:00 a1/p1',
      'End Time': '14:20:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '14:20:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'DOWNTOWN WALKAROUND',
      'Event Description':
        'Join us for a lovely tour of Toronto’s downtown with 1000 of your newest friends and classmates',
      'Start Time': '15:00:00 a1/p1',
      'End Time': '18:00:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'UNWIND NIGHT',
      'Event Location': 'GB303',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'TUESDAY AUGUST 27': [
    {
      'Event Name': 'MEET WITH YOUR GROUP',
      'Event Location': 'Front Campus',
      'Start Time': '8:15:00 a1/p1',
      'End Time': '8:45:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'CONSENT WORKSHOP',
      'Start Time': '9:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '11:00:00 a1/p1',
      'End Time': '11:20:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '11:20:00 a1/p1',
      'End Time': '12:20:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '12:20:00 a1/p1',
      'End Time': '13:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'ACADEMIC SUCCESS SEMINAR',
      'Event Description':
        "Learn from some of your amazing new TA's about all the strategies you need to know for success here at UofT Engineering!",
      'Start Time': '13:30:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'BUILD BATTLE',
      'Event Description':
        "Your first of many design challenges at UofT Engineering, except its probably the one of the coolest ones you do! Work with your frosh group to tackle your piece of the puzzle for this year's unique design challenge, coming together to build something truly amazing as a 2T8 class!",
      'Start Time': '15:00:00 a1/p1',
      'End Time': '16:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '16:30:00 a1/p1',
      'End Time': '18:00:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'CHEER OFF',
      'Start Time': '18:00:00 a1/p1',
      'End Time': '18:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'TOTES & TRIVIA',
      'Event Location': 'GB303',
      'Start Time': '7:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'WEDNESDAY AUGUST 28': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'SKULE™ HUNT',
      'Event Description':
        'SKULE™ HUNT: The longest items list you’ve ever seen. Join us for a full fledged scavenger hunt all over the city of Toronto!',
      'Start Time': '5:00 PM',
      'End Time': '11:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'THURSDAY AUGUST 29': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'CLUBS FAIR',
      'Event Location': 'Bahen Lobby',
      'Event Description':
        'Interested in joining a club, intramural sport or getting involved with the Engineering Society (EngSoc)? Attend the Engineering Clubs Fair to learn more about the 100+ ways you can get involved.</a>.',
      'Start Time': '11:00 AM',
      'End Time': '2:00 PM',
      Color: 'yellow',
    },
    {
      'Event Name': 'COMMON ROOM GAME NIGHT',
      'Event Description':
        "Sign up for game night <a href='https://docs.google.com/forms/d/e/1FAIpQLSfDGU1ejsC8bIwtHwCWC0YiEIULjcpsCm4yJ3x2cRvwCBIA7Q/viewform'>here</a>!",
      'Event Location': 'MB225',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'FRIDAY AUGUST 30': [
    {
      'Event Name': 'F!ROSH OLYMPIKS',
      'Start Time': '10:00 AM',
      'End Time': '5:00 PM',
      Color: 'purple',
    },
    {
      'Event Name': 'SKULE’S GOT TALENT',
      'Event Description':
        "Sign up for the talent show <a href='https://docs.google.com/forms/d/e/1FAIpQLSf4O3uIvwVlFQ-kuobHp_OUWwPA9f7kfUvzSWhrBMv_jQqgZg/viewform'>here</a>!",
      'Event Location': 'GB Front Steps',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
};
export const dataPhi = {
  'MONDAY AUGUST 26': [
    {
      'Event Name': 'CHECK-IN & MEET YOUR F!ROSH GROUP',
      'Start Time': '7:30:00 a1/p1',
      'End Time': '8:30:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'MATRICULATION',
      'Event Description':
        'Our kickoff the frosh week, and introduction to all things SKULE™. We all gather in to Convocation Hall',
      'Start Time': '8:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '11:00:00 a1/p1',
      'End Time': '12:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '12:30:00 a1/p1',
      'End Time': '13:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '13:30:00 a1/p1',
      'End Time': '14:00:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'D!YE STATION',
      'Event Description':
        'When I say purple you say purple! Where F!rosh and Leedurs alike dye their bodies (or parts thereof) purple. The colour purple represents great significance in the traditions of engineering schools across Canada.',
      'Start Time': '14:00:00 a1/p1',
      'End Time': '14:30:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '14:30:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'DOWNTOWN WALKAROUND',
      'Event Description':
        'Join us for a lovely tour of Toronto’s downtown with 1000 of your newest friends and classmates',
      'Start Time': '15:00:00 a1/p1',
      'End Time': '18:00:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'UNWIND NIGHT',
      'Event Location': 'GB303',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'TUESDAY AUGUST 27': [
    {
      'Event Name': 'MEET WITH YOUR GROUP',
      'Event Location': 'Front Campus',
      'Start Time': '8:15:00 a1/p1',
      'End Time': '8:45:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'CONSENT WORKSHOP',
      'Start Time': '9:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '11:00:00 a1/p1',
      'End Time': '12:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '12:30:00 a1/p1',
      'End Time': '13:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'ACADEMIC SUCCESS SEMINAR',
      'Event Description':
        "Learn from some of your amazing new TA's about all the strategies you need to know for success here at UofT Engineering!",
      'Start Time': '13:30:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '15:00:00 a1/p1',
      'End Time': '16:10:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'BUILD BATTLE',
      'Event Description':
        "Your first of many design challenges at UofT Engineering, except its probably the one of the coolest ones you do! Work with your frosh group to tackle your piece of the puzzle for this year's unique design challenge, coming together to build something truly amazing as a 2T8 class!",
      'Start Time': '16:20:00 a1/p1',
      'End Time': '17:40:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'CHEER OFF',
      'Start Time': '18:00:00 a1/p1',
      'End Time': '18:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'TOTES & TRIVIA',
      'Event Location': 'GB303',
      'Start Time': '7:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'WEDNESDAY AUGUST 28': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'SKULE™ HUNT',
      'Event Description':
        'SKULE™ HUNT: The longest items list you’ve ever seen. Join us for a full fledged scavenger hunt all over the city of Toronto!',
      'Start Time': '5:00 PM',
      'End Time': '11:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'THURSDAY AUGUST 29': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'CLUBS FAIR',
      'Event Location': 'Bahen Lobby',
      'Event Description':
        'Interested in joining a club, intramural sport or getting involved with the Engineering Society (EngSoc)? Attend the Engineering Clubs Fair to learn more about the 100+ ways you can get involved.</a>.',
      'Start Time': '11:00 AM',
      'End Time': '2:00 PM',
      Color: 'yellow',
    },
    {
      'Event Name': 'COMMON ROOM GAME NIGHT',
      'Event Description':
        "Sign up for game night <a href='https://docs.google.com/forms/d/e/1FAIpQLSfDGU1ejsC8bIwtHwCWC0YiEIULjcpsCm4yJ3x2cRvwCBIA7Q/viewform'>here</a>!",
      'Event Location': 'MB225',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'FRIDAY AUGUST 30': [
    {
      'Event Name': 'F!ROSH OLYMPIKS',
      'Start Time': '10:00 AM',
      'End Time': '5:00 PM',
      Color: 'purple',
    },
    {
      'Event Name': 'SKULE’S GOT TALENT',
      'Event Description':
        "Sign up for the talent show <a href='https://docs.google.com/forms/d/e/1FAIpQLSf4O3uIvwVlFQ-kuobHp_OUWwPA9f7kfUvzSWhrBMv_jQqgZg/viewform'>here</a>!",
      'Event Location': 'GB Front Steps',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
};
export const dataPi = {
  'MONDAY AUGUST 26': [
    {
      'Event Name': 'CHECK-IN & MEET YOUR F!ROSH GROUP',
      'Start Time': '7:30:00 a1/p1',
      'End Time': '8:30:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'MATRICULATION',
      'Event Description':
        'Our kickoff the frosh week, and introduction to all things SKULE™. We all gather in to Convocation Hall',
      'Start Time': '8:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '11:00:00 a1/p1',
      'End Time': '11:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'D!YE STATION',
      'Event Description':
        'When I say purple you say purple! Where F!rosh and Leedurs alike dye their bodies (or parts thereof) purple. The colour purple represents great significance in the traditions of engineering schools across Canada.',
      'Start Time': '11:30:00 a1/p1',
      'End Time': '12:00:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '12:00:00 a1/p1',
      'End Time': '12:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '12:30:00 a1/p1',
      'End Time': '13:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '13:30:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'DOWNTOWN WALKAROUND',
      'Event Description':
        'Join us for a lovely tour of Toronto’s downtown with 1000 of your newest friends and classmates',
      'Start Time': '15:00:00 a1/p1',
      'End Time': '18:00:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'UNWIND NIGHT',
      'Event Location': 'GB303',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'TUESDAY AUGUST 27': [
    {
      'Event Name': 'MEET WITH YOUR GROUP',
      'Event Location': 'Front Campus',
      'Start Time': '8:15:00 a1/p1',
      'End Time': '8:45:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'CONSENT WORKSHOP',
      'Start Time': '9:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'BUILD BATTLE',
      'Event Description':
        "Your first of many design challenges at UofT Engineering, except its probably the one of the coolest ones you do! Work with your frosh group to tackle your piece of the puzzle for this year's unique design challenge, coming together to build something truly amazing as a 2T8 class!",
      'Start Time': '11:00:00 a1/p1',
      'End Time': '12:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '12:30:00 a1/p1',
      'End Time': '13:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'ACADEMIC SUCCESS SEMINAR',
      'Event Description':
        "Learn from some of your amazing new TA's about all the strategies you need to know for success here at UofT Engineering!",
      'Start Time': '13:30:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '15:00:00 a1/p1',
      'End Time': '18:00:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'CHEER OFF',
      'Start Time': '18:00:00 a1/p1',
      'End Time': '18:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'TOTES & TRIVIA',
      'Event Location': 'GB303',
      'Start Time': '7:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'WEDNESDAY AUGUST 28': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'SKULE™ HUNT',
      'Event Description':
        'SKULE™ HUNT: The longest items list you’ve ever seen. Join us for a full fledged scavenger hunt all over the city of Toronto!',
      'Start Time': '5:00 PM',
      'End Time': '11:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'THURSDAY AUGUST 29': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'CLUBS FAIR',
      'Event Location': 'Bahen Lobby',
      'Event Description':
        'Interested in joining a club, intramural sport or getting involved with the Engineering Society (EngSoc)? Attend the Engineering Clubs Fair to learn more about the 100+ ways you can get involved.</a>.',
      'Start Time': '11:00 AM',
      'End Time': '2:00 PM',
      Color: 'yellow',
    },
    {
      'Event Name': 'COMMON ROOM GAME NIGHT',
      'Event Description':
        "Sign up for game night <a href='https://docs.google.com/forms/d/e/1FAIpQLSfDGU1ejsC8bIwtHwCWC0YiEIULjcpsCm4yJ3x2cRvwCBIA7Q/viewform'>here</a>!",
      'Event Location': 'MB225',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'FRIDAY AUGUST 30': [
    {
      'Event Name': 'F!ROSH OLYMPIKS',
      'Start Time': '10:00 AM',
      'End Time': '5:00 PM',
      Color: 'purple',
    },
    {
      'Event Name': 'SKULE’S GOT TALENT',
      'Event Description':
        "Sign up for the talent show <a href='https://docs.google.com/forms/d/e/1FAIpQLSf4O3uIvwVlFQ-kuobHp_OUWwPA9f7kfUvzSWhrBMv_jQqgZg/viewform'>here</a>!",
      'Event Location': 'GB Front Steps',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
};
export const dataPsi = {
  'MONDAY AUGUST 26': [
    {
      'Event Name': 'CHECK-IN & MEET YOUR F!ROSH GROUP',
      'Start Time': '7:30:00 a1/p1',
      'End Time': '8:30:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'MATRICULATION',
      'Event Description':
        'Our kickoff the frosh week, and introduction to all things SKULE™. We all gather in to Convocation Hall',
      'Start Time': '8:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '11:00:00 a1/p1',
      'End Time': '11:20:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '11:20:00 a1/p1',
      'End Time': '12:20:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '12:20:00 a1/p1',
      'End Time': '12:50:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'D!YE STATION',
      'Event Description':
        'When I say purple you say purple! Where F!rosh and Leedurs alike dye their bodies (or parts thereof) purple. The colour purple represents great significance in the traditions of engineering schools across Canada.',
      'Start Time': '12:50:00 a1/p1',
      'End Time': '13:20:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '13:20:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'DOWNTOWN WALKAROUND',
      'Event Description':
        'Join us for a lovely tour of Toronto’s downtown with 1000 of your newest friends and classmates',
      'Start Time': '15:00:00 a1/p1',
      'End Time': '18:00:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'UNWIND NIGHT',
      'Event Location': 'GB303',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'TUESDAY AUGUST 27': [
    {
      'Event Name': 'MEET WITH YOUR GROUP',
      'Event Location': 'Front Campus',
      'Start Time': '8:15:00 a1/p1',
      'End Time': '8:45:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'CONSENT WORKSHOP',
      'Start Time': '9:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'BUILD BATTLE',
      'Event Description':
        "Your first of many design challenges at UofT Engineering, except its probably the one of the coolest ones you do! Work with your frosh group to tackle your piece of the puzzle for this year's unique design challenge, coming together to build something truly amazing as a 2T8 class!",
      'Start Time': '11:00:00 a1/p1',
      'End Time': '12:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '12:30:00 a1/p1',
      'End Time': '13:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'ACADEMIC SUCCESS SEMINAR',
      'Event Description':
        "Learn from some of your amazing new TA's about all the strategies you need to know for success here at UofT Engineering!",
      'Start Time': '13:30:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '15:00:00 a1/p1',
      'End Time': '18:00:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'CHEER OFF',
      'Start Time': '18:00:00 a1/p1',
      'End Time': '18:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'TOTES & TRIVIA',
      'Event Location': 'GB303',
      'Start Time': '7:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'WEDNESDAY AUGUST 28': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'SKULE™ HUNT',
      'Event Description':
        'SKULE™ HUNT: The longest items list you’ve ever seen. Join us for a full fledged scavenger hunt all over the city of Toronto!',
      'Start Time': '5:00 PM',
      'End Time': '11:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'THURSDAY AUGUST 29': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'CLUBS FAIR',
      'Event Location': 'Bahen Lobby',
      'Event Description':
        'Interested in joining a club, intramural sport or getting involved with the Engineering Society (EngSoc)? Attend the Engineering Clubs Fair to learn more about the 100+ ways you can get involved.</a>.',
      'Start Time': '11:00 AM',
      'End Time': '2:00 PM',
      Color: 'yellow',
    },
    {
      'Event Name': 'COMMON ROOM GAME NIGHT',
      'Event Description':
        "Sign up for game night <a href='https://docs.google.com/forms/d/e/1FAIpQLSfDGU1ejsC8bIwtHwCWC0YiEIULjcpsCm4yJ3x2cRvwCBIA7Q/viewform'>here</a>!",
      'Event Location': 'MB225',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'FRIDAY AUGUST 30': [
    {
      'Event Name': 'F!ROSH OLYMPIKS',
      'Start Time': '10:00 AM',
      'End Time': '5:00 PM',
      Color: 'purple',
    },
    {
      'Event Name': 'SKULE’S GOT TALENT',
      'Event Description':
        "Sign up for the talent show <a href='https://docs.google.com/forms/d/e/1FAIpQLSf4O3uIvwVlFQ-kuobHp_OUWwPA9f7kfUvzSWhrBMv_jQqgZg/viewform'>here</a>!",
      'Event Location': 'GB Front Steps',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
};
export const dataRho = {
  'MONDAY AUGUST 26': [
    {
      'Event Name': 'CHECK-IN & MEET YOUR F!ROSH GROUP',
      'Start Time': '7:30:00 a1/p1',
      'End Time': '8:30:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'MATRICULATION',
      'Event Description':
        'Our kickoff the frosh week, and introduction to all things SKULE™. We all gather in to Convocation Hall',
      'Start Time': '8:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '11:00:00 a1/p1',
      'End Time': '11:10:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'D!YE STATION',
      'Event Description':
        'When I say purple you say purple! Where F!rosh and Leedurs alike dye their bodies (or parts thereof) purple. The colour purple represents great significance in the traditions of engineering schools across Canada.',
      'Start Time': '11:10:00 a1/p1',
      'End Time': '12:40:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '11:40:00 a1/p1',
      'End Time': '12:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '12:30:00 a1/p1',
      'End Time': '13:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '13:30:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'DOWNTOWN WALKAROUND',
      'Event Description':
        'Join us for a lovely tour of Toronto’s downtown with 1000 of your newest friends and classmates',
      'Start Time': '15:00:00 a1/p1',
      'End Time': '18:00:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'UNWIND NIGHT',
      'Event Location': 'GB303',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'TUESDAY AUGUST 27': [
    {
      'Event Name': 'MEET WITH YOUR GROUP',
      'Event Location': 'Front Campus',
      'Start Time': '8:15:00 a1/p1',
      'End Time': '8:45:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'CONSENT WORKSHOP',
      'Start Time': '9:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '11:00:00 a1/p1',
      'End Time': '11:20:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '11:20:00 a1/p1',
      'End Time': '12:20:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '12:20:00 a1/p1',
      'End Time': '13:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'ACADEMIC SUCCESS SEMINAR',
      'Event Description':
        "Learn from some of your amazing new TA's about all the strategies you need to know for success here at UofT Engineering!",
      'Start Time': '13:30:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'BUILD BATTLE',
      'Event Description':
        "Your first of many design challenges at UofT Engineering, except its probably the one of the coolest ones you do! Work with your frosh group to tackle your piece of the puzzle for this year's unique design challenge, coming together to build something truly amazing as a 2T8 class!",
      'Start Time': '15:00:00 a1/p1',
      'End Time': '16:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '16:30:00 a1/p1',
      'End Time': '18:00:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'CHEER OFF',
      'Start Time': '18:00:00 a1/p1',
      'End Time': '18:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'TOTES & TRIVIA',
      'Event Location': 'GB303',
      'Start Time': '7:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'WEDNESDAY AUGUST 28': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'SKULE™ HUNT',
      'Event Description':
        'SKULE™ HUNT: The longest items list you’ve ever seen. Join us for a full fledged scavenger hunt all over the city of Toronto!',
      'Start Time': '5:00 PM',
      'End Time': '11:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'THURSDAY AUGUST 29': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'CLUBS FAIR',
      'Event Location': 'Bahen Lobby',
      'Event Description':
        'Interested in joining a club, intramural sport or getting involved with the Engineering Society (EngSoc)? Attend the Engineering Clubs Fair to learn more about the 100+ ways you can get involved.</a>.',
      'Start Time': '11:00 AM',
      'End Time': '2:00 PM',
      Color: 'yellow',
    },
    {
      'Event Name': 'COMMON ROOM GAME NIGHT',
      'Event Description':
        "Sign up for game night <a href='https://docs.google.com/forms/d/e/1FAIpQLSfDGU1ejsC8bIwtHwCWC0YiEIULjcpsCm4yJ3x2cRvwCBIA7Q/viewform'>here</a>!",
      'Event Location': 'MB225',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'FRIDAY AUGUST 30': [
    {
      'Event Name': 'F!ROSH OLYMPIKS',
      'Start Time': '10:00 AM',
      'End Time': '5:00 PM',
      Color: 'purple',
    },
    {
      'Event Name': 'SKULE’S GOT TALENT',
      'Event Description':
        "Sign up for the talent show <a href='https://docs.google.com/forms/d/e/1FAIpQLSf4O3uIvwVlFQ-kuobHp_OUWwPA9f7kfUvzSWhrBMv_jQqgZg/viewform'>here</a>!",
      'Event Location': 'GB Front Steps',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
};
export const dataSigma = {
  'MONDAY AUGUST 26': [
    {
      'Event Name': 'CHECK-IN & MEET YOUR F!ROSH GROUP',
      'Start Time': '7:30:00 a1/p1',
      'End Time': '8:30:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'MATRICULATION',
      'Event Description':
        'Our kickoff the frosh week, and introduction to all things SKULE™. We all gather in to Convocation Hall',
      'Start Time': '8:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '11:00:00 a1/p1',
      'End Time': '11:20:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '11:20:00 a1/p1',
      'End Time': '12:20:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '12:20:00 a1/p1',
      'End Time': '13:20:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'D!YE STATION',
      'Event Description':
        'When I say purple you say purple! Where F!rosh and Leedurs alike dye their bodies (or parts thereof) purple. The colour purple represents great significance in the traditions of engineering schools across Canada.',
      'Start Time': '13:20:00 a1/p1',
      'End Time': '13:50:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '13:50:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'DOWNTOWN WALKAROUND',
      'Event Description':
        'Join us for a lovely tour of Toronto’s downtown with 1000 of your newest friends and classmates',
      'Start Time': '15:00:00 a1/p1',
      'End Time': '18:00:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'UNWIND NIGHT',
      'Event Location': 'GB303',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'TUESDAY AUGUST 27': [
    {
      'Event Name': 'MEET WITH YOUR GROUP',
      'Event Location': 'Front Campus',
      'Start Time': '8:15:00 a1/p1',
      'End Time': '8:45:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'CONSENT WORKSHOP',
      'Start Time': '9:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '11:00:00 a1/p1',
      'End Time': '11:20:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '11:20:00 a1/p1',
      'End Time': '12:20:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '12:20:00 a1/p1',
      'End Time': '13:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'ACADEMIC SUCCESS SEMINAR',
      'Event Description':
        "Learn from some of your amazing new TA's about all the strategies you need to know for success here at UofT Engineering!",
      'Start Time': '13:30:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'BUILD BATTLE',
      'Event Description':
        "Your first of many design challenges at UofT Engineering, except its probably the one of the coolest ones you do! Work with your frosh group to tackle your piece of the puzzle for this year's unique design challenge, coming together to build something truly amazing as a 2T8 class!",
      'Start Time': '15:00:00 a1/p1',
      'End Time': '16:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '16:30:00 a1/p1',
      'End Time': '18:00:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'CHEER OFF',
      'Start Time': '18:00:00 a1/p1',
      'End Time': '18:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'TOTES & TRIVIA',
      'Event Location': 'GB303',
      'Start Time': '7:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'WEDNESDAY AUGUST 28': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'SKULE™ HUNT',
      'Event Description':
        'SKULE™ HUNT: The longest items list you’ve ever seen. Join us for a full fledged scavenger hunt all over the city of Toronto!',
      'Start Time': '5:00 PM',
      'End Time': '11:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'THURSDAY AUGUST 29': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'CLUBS FAIR',
      'Event Location': 'Bahen Lobby',
      'Event Description':
        'Interested in joining a club, intramural sport or getting involved with the Engineering Society (EngSoc)? Attend the Engineering Clubs Fair to learn more about the 100+ ways you can get involved.</a>.',
      'Start Time': '11:00 AM',
      'End Time': '2:00 PM',
      Color: 'yellow',
    },
    {
      'Event Name': 'COMMON ROOM GAME NIGHT',
      'Event Description':
        "Sign up for game night <a href='https://docs.google.com/forms/d/e/1FAIpQLSfDGU1ejsC8bIwtHwCWC0YiEIULjcpsCm4yJ3x2cRvwCBIA7Q/viewform'>here</a>!",
      'Event Location': 'MB225',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'FRIDAY AUGUST 30': [
    {
      'Event Name': 'F!ROSH OLYMPIKS',
      'Start Time': '10:00 AM',
      'End Time': '5:00 PM',
      Color: 'purple',
    },
    {
      'Event Name': 'SKULE’S GOT TALENT',
      'Event Description':
        "Sign up for the talent show <a href='https://docs.google.com/forms/d/e/1FAIpQLSf4O3uIvwVlFQ-kuobHp_OUWwPA9f7kfUvzSWhrBMv_jQqgZg/viewform'>here</a>!",
      'Event Location': 'GB Front Steps',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
};
export const dataTau = {
  'MONDAY AUGUST 26': [
    {
      'Event Name': 'CHECK-IN & MEET YOUR F!ROSH GROUP',
      'Start Time': '7:30:00 a1/p1',
      'End Time': '8:30:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'MATRICULATION',
      'Event Description':
        'Our kickoff the frosh week, and introduction to all things SKULE™. We all gather in to Convocation Hall',
      'Start Time': '8:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '11:00:00 a1/p1',
      'End Time': '11:20:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '11:20:00 a1/p1',
      'End Time': '12:20:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '12:20:00 a1/p1',
      'End Time': '13:10:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'D!YE STATION',
      'Event Description':
        'When I say purple you say purple! Where F!rosh and Leedurs alike dye their bodies (or parts thereof) purple. The colour purple represents great significance in the traditions of engineering schools across Canada.',
      'Start Time': '13:10:00 a1/p1',
      'End Time': '13:40:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '13:40:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'DOWNTOWN WALKAROUND',
      'Event Description':
        'Join us for a lovely tour of Toronto’s downtown with 1000 of your newest friends and classmates',
      'Start Time': '15:00:00 a1/p1',
      'End Time': '18:00:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'UNWIND NIGHT',
      'Event Location': 'GB303',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'TUESDAY AUGUST 27': [
    {
      'Event Name': 'MEET WITH YOUR GROUP',
      'Event Location': 'Front Campus',
      'Start Time': '8:15:00 a1/p1',
      'End Time': '8:45:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'CONSENT WORKSHOP',
      'Start Time': '9:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '11:00:00 a1/p1',
      'End Time': '11:20:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '11:20:00 a1/p1',
      'End Time': '12:20:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '12:20:00 a1/p1',
      'End Time': '13:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'ACADEMIC SUCCESS SEMINAR',
      'Event Description':
        "Learn from some of your amazing new TA's about all the strategies you need to know for success here at UofT Engineering!",
      'Start Time': '13:30:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'BUILD BATTLE',
      'Event Description':
        "Your first of many design challenges at UofT Engineering, except its probably the one of the coolest ones you do! Work with your frosh group to tackle your piece of the puzzle for this year's unique design challenge, coming together to build something truly amazing as a 2T8 class!",
      'Start Time': '15:00:00 a1/p1',
      'End Time': '16:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '16:30:00 a1/p1',
      'End Time': '18:00:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'CHEER OFF',
      'Start Time': '18:00:00 a1/p1',
      'End Time': '18:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'TOTES & TRIVIA',
      'Event Location': 'GB303',
      'Start Time': '7:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'WEDNESDAY AUGUST 28': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'SKULE™ HUNT',
      'Event Description':
        'SKULE™ HUNT: The longest items list you’ve ever seen. Join us for a full fledged scavenger hunt all over the city of Toronto!',
      'Start Time': '5:00 PM',
      'End Time': '11:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'THURSDAY AUGUST 29': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'CLUBS FAIR',
      'Event Location': 'Bahen Lobby',
      'Event Description':
        'Interested in joining a club, intramural sport or getting involved with the Engineering Society (EngSoc)? Attend the Engineering Clubs Fair to learn more about the 100+ ways you can get involved.</a>.',
      'Start Time': '11:00 AM',
      'End Time': '2:00 PM',
      Color: 'yellow',
    },
    {
      'Event Name': 'COMMON ROOM GAME NIGHT',
      'Event Description':
        "Sign up for game night <a href='https://docs.google.com/forms/d/e/1FAIpQLSfDGU1ejsC8bIwtHwCWC0YiEIULjcpsCm4yJ3x2cRvwCBIA7Q/viewform'>here</a>!",
      'Event Location': 'MB225',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'FRIDAY AUGUST 30': [
    {
      'Event Name': 'F!ROSH OLYMPIKS',
      'Start Time': '10:00 AM',
      'End Time': '5:00 PM',
      Color: 'purple',
    },
    {
      'Event Name': 'SKULE’S GOT TALENT',
      'Event Description':
        "Sign up for the talent show <a href='https://docs.google.com/forms/d/e/1FAIpQLSf4O3uIvwVlFQ-kuobHp_OUWwPA9f7kfUvzSWhrBMv_jQqgZg/viewform'>here</a>!",
      'Event Location': 'GB Front Steps',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
};
export const dataTheta = {
  'MONDAY AUGUST 26': [
    {
      'Event Name': 'CHECK-IN & MEET YOUR F!ROSH GROUP',
      'Start Time': '7:30:00 a1/p1',
      'End Time': '8:30:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'MATRICULATION',
      'Event Description':
        'Our kickoff the frosh week, and introduction to all things SKULE™. We all gather in to Convocation Hall',
      'Start Time': '8:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '11:00:00 a1/p1',
      'End Time': '11:20:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '11:20:00 a1/p1',
      'End Time': '12:20:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '12:20:00 a1/p1',
      'End Time': '14:20:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'D!YE STATION',
      'Event Description':
        'When I say purple you say purple! Where F!rosh and Leedurs alike dye their bodies (or parts thereof) purple. The colour purple represents great significance in the traditions of engineering schools across Canada.',
      'Start Time': '14:20:00 a1/p1',
      'End Time': '14:50:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '14:50:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'DOWNTOWN WALKAROUND',
      'Event Description':
        'Join us for a lovely tour of Toronto’s downtown with 1000 of your newest friends and classmates',
      'Start Time': '15:00:00 a1/p1',
      'End Time': '18:00:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'UNWIND NIGHT',
      'Event Location': 'GB303',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'TUESDAY AUGUST 27': [
    {
      'Event Name': 'MEET WITH YOUR GROUP',
      'Event Location': 'Front Campus',
      'Start Time': '8:15:00 a1/p1',
      'End Time': '8:45:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'CONSENT WORKSHOP',
      'Start Time': '9:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'BUILD BATTLE',
      'Event Description':
        "Your first of many design challenges at UofT Engineering, except its probably the one of the coolest ones you do! Work with your frosh group to tackle your piece of the puzzle for this year's unique design challenge, coming together to build something truly amazing as a 2T8 class!",
      'Start Time': '11:00:00 a1/p1',
      'End Time': '12:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '12:30:00 a1/p1',
      'End Time': '13:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'ACADEMIC SUCCESS SEMINAR',
      'Event Description':
        "Learn from some of your amazing new TA's about all the strategies you need to know for success here at UofT Engineering!",
      'Start Time': '13:30:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '15:00:00 a1/p1',
      'End Time': '18:00:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'CHEER OFF',
      'Start Time': '18:00:00 a1/p1',
      'End Time': '18:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'TOTES & TRIVIA',
      'Event Location': 'GB303',
      'Start Time': '7:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'WEDNESDAY AUGUST 28': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'SKULE™ HUNT',
      'Event Description':
        'SKULE™ HUNT: The longest items list you’ve ever seen. Join us for a full fledged scavenger hunt all over the city of Toronto!',
      'Start Time': '5:00 PM',
      'End Time': '11:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'THURSDAY AUGUST 29': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'CLUBS FAIR',
      'Event Location': 'Bahen Lobby',
      'Event Description':
        'Interested in joining a club, intramural sport or getting involved with the Engineering Society (EngSoc)? Attend the Engineering Clubs Fair to learn more about the 100+ ways you can get involved.</a>.',
      'Start Time': '11:00 AM',
      'End Time': '2:00 PM',
      Color: 'yellow',
    },
    {
      'Event Name': 'COMMON ROOM GAME NIGHT',
      'Event Description':
        "Sign up for game night <a href='https://docs.google.com/forms/d/e/1FAIpQLSfDGU1ejsC8bIwtHwCWC0YiEIULjcpsCm4yJ3x2cRvwCBIA7Q/viewform'>here</a>!",
      'Event Location': 'MB225',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'FRIDAY AUGUST 30': [
    {
      'Event Name': 'F!ROSH OLYMPIKS',
      'Start Time': '10:00 AM',
      'End Time': '5:00 PM',
      Color: 'purple',
    },
    {
      'Event Name': 'SKULE’S GOT TALENT',
      'Event Description':
        "Sign up for the talent show <a href='https://docs.google.com/forms/d/e/1FAIpQLSf4O3uIvwVlFQ-kuobHp_OUWwPA9f7kfUvzSWhrBMv_jQqgZg/viewform'>here</a>!",
      'Event Location': 'GB Front Steps',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
};
export const dataUpsilon = {
  'MONDAY AUGUST 26': [
    {
      'Event Name': 'CHECK-IN & MEET YOUR F!ROSH GROUP',
      'Start Time': '7:30:00 a1/p1',
      'End Time': '8:30:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'MATRICULATION',
      'Event Description':
        'Our kickoff the frosh week, and introduction to all things SKULE™. We all gather in to Convocation Hall',
      'Start Time': '8:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '11:00:00 a1/p1',
      'End Time': '11:40:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'D!YE STATION',
      'Event Description':
        'When I say purple you say purple! Where F!rosh and Leedurs alike dye their bodies (or parts thereof) purple. The colour purple represents great significance in the traditions of engineering schools across Canada.',
      'Start Time': '11:40:00 a1/p1',
      'End Time': '12:20:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '12:20:00 a1/p1',
      'End Time': '12:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '12:30:00 a1/p1',
      'End Time': '13:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '13:30:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'DOWNTOWN WALKAROUND',
      'Event Description':
        'Join us for a lovely tour of Toronto’s downtown with 1000 of your newest friends and classmates',
      'Start Time': '15:00:00 a1/p1',
      'End Time': '18:00:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'UNWIND NIGHT',
      'Event Location': 'GB303',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'TUESDAY AUGUST 27': [
    {
      'Event Name': 'MEET WITH YOUR GROUP',
      'Event Location': 'Front Campus',
      'Start Time': '8:15:00 a1/p1',
      'End Time': '8:45:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'CONSENT WORKSHOP',
      'Start Time': '9:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '11:00:00 a1/p1',
      'End Time': '12:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '12:30:00 a1/p1',
      'End Time': '13:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'ACADEMIC SUCCESS SEMINAR',
      'Event Description':
        "Learn from some of your amazing new TA's about all the strategies you need to know for success here at UofT Engineering!",
      'Start Time': '13:30:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '15:00:00 a1/p1',
      'End Time': '16:10:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'BUILD BATTLE',
      'Event Description':
        "Your first of many design challenges at UofT Engineering, except its probably the one of the coolest ones you do! Work with your frosh group to tackle your piece of the puzzle for this year's unique design challenge, coming together to build something truly amazing as a 2T8 class!",
      'Start Time': '16:20:00 a1/p1',
      'End Time': '17:40:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'CHEER OFF',
      'Start Time': '18:00:00 a1/p1',
      'End Time': '18:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'TOTES & TRIVIA',
      'Event Location': 'GB303',
      'Start Time': '7:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'WEDNESDAY AUGUST 28': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'SKULE™ HUNT',
      'Event Description':
        'SKULE™ HUNT: The longest items list you’ve ever seen. Join us for a full fledged scavenger hunt all over the city of Toronto!',
      'Start Time': '5:00 PM',
      'End Time': '11:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'THURSDAY AUGUST 29': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'CLUBS FAIR',
      'Event Location': 'Bahen Lobby',
      'Event Description':
        'Interested in joining a club, intramural sport or getting involved with the Engineering Society (EngSoc)? Attend the Engineering Clubs Fair to learn more about the 100+ ways you can get involved.</a>.',
      'Start Time': '11:00 AM',
      'End Time': '2:00 PM',
      Color: 'yellow',
    },
    {
      'Event Name': 'COMMON ROOM GAME NIGHT',
      'Event Description':
        "Sign up for game night <a href='https://docs.google.com/forms/d/e/1FAIpQLSfDGU1ejsC8bIwtHwCWC0YiEIULjcpsCm4yJ3x2cRvwCBIA7Q/viewform'>here</a>!",
      'Event Location': 'MB225',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'FRIDAY AUGUST 30': [
    {
      'Event Name': 'F!ROSH OLYMPIKS',
      'Start Time': '10:00 AM',
      'End Time': '5:00 PM',
      Color: 'purple',
    },
    {
      'Event Name': 'SKULE’S GOT TALENT',
      'Event Description':
        "Sign up for the talent show <a href='https://docs.google.com/forms/d/e/1FAIpQLSf4O3uIvwVlFQ-kuobHp_OUWwPA9f7kfUvzSWhrBMv_jQqgZg/viewform'>here</a>!",
      'Event Location': 'GB Front Steps',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
};
export const dataZeta = {
  'MONDAY AUGUST 26': [
    {
      'Event Name': 'CHECK-IN & MEET YOUR F!ROSH GROUP',
      'Start Time': '7:30:00 a1/p1',
      'End Time': '8:30:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'MATRICULATION',
      'Event Description':
        'Our kickoff the frosh week, and introduction to all things SKULE™. We all gather in to Convocation Hall',
      'Start Time': '8:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '11:00:00 a1/p1',
      'End Time': '11:20:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '11:20:00 a1/p1',
      'End Time': '12:20:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'D!YE STATION',
      'Event Description':
        'When I say purple you say purple! Where F!rosh and Leedurs alike dye their bodies (or parts thereof) purple. The colour purple represents great significance in the traditions of engineering schools across Canada.',
      'Start Time': '12:20:00 a1/p1',
      'End Time': '12:50:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'F!ROSH GAMES',
      'Event Description':
        'Compete against other frosh groups in the craziest competitions imaginable',
      'Start Time': '12:50:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'DOWNTOWN WALKAROUND',
      'Event Description':
        'Join us for a lovely tour of Toronto’s downtown with 1000 of your newest friends and classmates',
      'Start Time': '15:00:00 a1/p1',
      'End Time': '18:00:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'UNWIND NIGHT',
      'Event Location': 'GB303',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'TUESDAY AUGUST 27': [
    {
      'Event Name': 'MEET WITH YOUR GROUP',
      'Event Location': 'Front Campus',
      'Start Time': '8:15:00 a1/p1',
      'End Time': '8:45:00 a1/p1',
      Color: 'purple',
    },
    {
      'Event Name': 'CONSENT WORKSHOP',
      'Start Time': '9:30:00 a1/p1',
      'End Time': '10:30:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'BUILD BATTLE',
      'Event Description':
        "Your first of many design challenges at UofT Engineering, except its probably the one of the coolest ones you do! Work with your frosh group to tackle your piece of the puzzle for this year's unique design challenge, coming together to build something truly amazing as a 2T8 class!",
      'Start Time': '11:00:00 a1/p1',
      'End Time': '12:30:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'LUNCH',
      'Start Time': '12:30:00 a1/p1',
      'End Time': '13:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'ACADEMIC SUCCESS SEMINAR',
      'Event Description':
        "Learn from some of your amazing new TA's about all the strategies you need to know for success here at UofT Engineering!",
      'Start Time': '13:30:00 a1/p1',
      'End Time': '15:00:00 a1/p1',
      Color: 'dark-purple',
    },
    {
      'Event Name': 'CAMPUS TOURS',
      'Event Description':
        'Where our Frosh leedurs will lead you through a tour of campus to find all the best places to study, work on projects, and nap!',
      'Start Time': '15:00:00 a1/p1',
      'End Time': '18:00:00 a1/p1',
      Color: 'yellow',
    },
    {
      'Event Name': 'CHEER OFF',
      'Start Time': '18:00:00 a1/p1',
      'End Time': '18:30:00 a1/p1',
      Color: 'green',
    },
    {
      'Event Name': 'TOTES & TRIVIA',
      'Event Location': 'GB303',
      'Start Time': '7:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'WEDNESDAY AUGUST 28': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'SKULE™ HUNT',
      'Event Description':
        'SKULE™ HUNT: The longest items list you’ve ever seen. Join us for a full fledged scavenger hunt all over the city of Toronto!',
      'Start Time': '5:00 PM',
      'End Time': '11:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'THURSDAY AUGUST 29': [
    {
      'Event Name': 'FACULTY EVENTS',
      'Event Description': `Check out more information about Faculty Events here: <a href='https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/'>Faculty Events</a>`,
      'Start Time': ' ',
      'End Time': ' ',
      Color: 'gray',
    },
    {
      'Event Name': 'CLUBS FAIR',
      'Event Location': 'Bahen Lobby',
      'Event Description':
        'Interested in joining a club, intramural sport or getting involved with the Engineering Society (EngSoc)? Attend the Engineering Clubs Fair to learn more about the 100+ ways you can get involved.</a>.',
      'Start Time': '11:00 AM',
      'End Time': '2:00 PM',
      Color: 'yellow',
    },
    {
      'Event Name': 'COMMON ROOM GAME NIGHT',
      'Event Description':
        "Sign up for game night <a href='https://docs.google.com/forms/d/e/1FAIpQLSfDGU1ejsC8bIwtHwCWC0YiEIULjcpsCm4yJ3x2cRvwCBIA7Q/viewform'>here</a>!",
      'Event Location': 'MB225',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
  'FRIDAY AUGUST 30': [
    {
      'Event Name': 'F!ROSH OLYMPIKS',
      'Start Time': '10:00 AM',
      'End Time': '5:00 PM',
      Color: 'purple',
    },
    {
      'Event Name': 'SKULE’S GOT TALENT',
      'Event Description':
        "Sign up for the talent show <a href='https://docs.google.com/forms/d/e/1FAIpQLSf4O3uIvwVlFQ-kuobHp_OUWwPA9f7kfUvzSWhrBMv_jQqgZg/viewform'>here</a>!",
      'Event Location': 'GB Front Steps',
      'Start Time': '6:00 PM',
      'End Time': '9:00 PM',
      Color: 'dark-purple',
    },
    {
      'Event Name': '****',
      'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': '11:00 PM',
      Color: 'purple',
    },
  ],
};

// for home page
export const data = {
  'Monday August 25': [
    {
      'Event Name': 'Meet your F!rosh Group',
      'Start Time': '8:00 AM',
      'Event Location': 'GB Front Steps',
      'End Time': '9:00 AM',
      Color: 'break',
    },
    {
      'Event Name': 'Matriculation',
      'Event Location': 'Convocation Hall',
      'Event Description':
        'F!rosh Week Level 1, your introduction to all things Skule™. The Frosh, faculty, and upper years all gather in Convocation Hall for the Frosh’s teaser trailer at the community and all of the traditions, culture and opportunities offered at UofT Engineering.',
      'Start Time': '9:00 AM',
      'End Time': '11:00 AM',
      Color: 'long',
    },
    {
      'Event Name': 'Lunch',
      'Start Time': '11:00 AM',
      'End Time': '12:00 PM',
      Color: 'break',
    },
    {
      'Event Name': 'F!rosh Games + D!ye Station',
      'Event Description':
        '<b>F!rosh Games:</b> A series of fun, physical challenges that allows students to let loose, compete against other F!rosh groups and get to know each other in a dynamic fashion. These competitions can range from an obstacle course to a classic sport with an engineering twist.<br /><b>D!ye:</b> A 40+ year tradition where F!rosh and Leedurs dye their bodies purple. This player cosmetic represents great significance in the traditions of engineering schools across Canada, as it honours the engineers that came before us.',
      'Start Time': '12:00 PM',
      'End Time': '3:00 PM',
      Color: 'long',
    },
    {
      'Event Name': 'Downtown Walkaround',
      'Event Description':
        'A tour of downtown Toronto where thousands of students display their Skule™ spirit by parading and emoting from the St. George campus to Nathan Phillips Square.',
      'Start Time': '3:00 PM',
      'End Time': '5:00 PM',
      Color: 'long',
    },
    {
      'Event Name': 'Break/Dinner',
      // 'Event Location': 'GB303',
      'Start Time': '5:00 PM',
      'End Time': '6:00 PM',
      Color: 'break',
    },
    {
      'Event Name': 'Nitelife',
      'Event Description':
        'F!rosh Week goes dark mode with various games and activities run in the evening hours to continue the fun, offering Frosh more experiences to connect. Activities are high and low energy.',
      // 'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': 'Late',
      Color: 'night',
    },
  ],
  'Tuesday August 26': [
    {
      'Event Name': 'Academic Success Seminar',
      // 'Event Location': 'Front Campus',
      'Event Description':
        "Learn from some of your amazing new TA's about all the strategies you need to know for success here at UofT Engineering!",
      'Start Time': '8:00 AM',
      'End Time': '10:00 AM',
      Color: 'other',
    },
    {
      'Event Name': 'Campus Tours + Build Battle',
      'Event Description':
        '<b>Campus Tour:</b> F!rosh Leedurs guide Frosh through a tour of campus to find the best places to study, socialize and share stories about their time across campus. Take your minimap into the real world and find those secret levels. <br /><b>Build Battle:</b> First we mine, now you CRAFT! Put your skills to the test with a *POWER DRILL* *WOOD* *MARKERS* and whatever scraps your inventory picked up to create an epic build!',
      'Start Time': '10:00 AM',
      'End Time': '12:00 PM',
      Color: 'long',
    },
    {
      'Event Name': 'Lunch',
      'Start Time': '12:00 PM',
      'End Time': '1:00 PM',
      Color: 'break',
    },
    {
      'Event Name': 'Campus Tours + Build Battle',
      'Event Description':
        '<b>Campus Tour:</b> F!rosh Leedurs guide Frosh through a tour of campus to find the best places to study, socialize and share stories about their time across campus. Take your minimap into the real world and find those secret levels. <br /><b>Build Battle:</b> First we mine, now you CRAFT! Put your skills to the test with a *POWER DRILL* *WOOD* *MARKERS* and whatever scraps your inventory picked up to create an epic build!',
      'Start Time': '1:00 PM',
      'End Time': '5:00 PM',
      Color: 'long',
    },
    {
      'Event Name': 'Cheer-Off!',
      'Event Description': 'The Final Boss: AHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHH',
      'Start Time': '5:00 PM',
      'End Time': '6:00 PM',
      Color: 'general',
    },
    {
      'Event Name': 'Break/Dinner',
      // 'Event Location': 'GB303',
      'Start Time': '6:00 PM',
      'End Time': '7:00 PM',
      Color: 'break',
    },
    {
      'Event Name': 'Nitelife',
      'Event Description':
        'F!rosh Week goes dark mode with various games and activities run in the evening hours to continue the fun, offering Frosh more experiences to connect. Activities are high and low energy.',
      // 'Event Location': 'The Pit',
      'Start Time': '7:00 PM',
      'End Time': 'Late',
      Color: 'night',
    },
  ],
  'Wednesday August 27': [
    {
      'Event Name': 'Consent Seminar',
      'Event Description': `Attend the consent workshop and be entered to win some amazing prizes!`,
      'Start Time': '9:00 AM',
      'End Time': '11:00 AM',
      Color: 'other',
    },
    {
      'Event Name': 'Clubs Fair',
      'Event Location': 'Bahen Lobby',
      'Event Description':
        'Interested in joining a club, intramural sport or getting involved with the Engineering Society (EngSoc)? Attend the Engineering Clubs Fair to learn more about the 100+ ways you can get involved.</a>',
      'Start Time': '11:00 AM',
      'End Time': '5:00 PM',
      Color: 'long',
    },
    {
      'Event Name': 'Break/Dinner',
      // 'Event Location': 'GB303',
      'Start Time': '5:00 PM',
      'End Time': '6:00 PM',
      Color: 'break',
    },
    {
      'Event Name': 'Skule™ Hunt',
      'Event Description':
        'The Skule™ twist on a traditional Scavenger Hunt, where students search for unique items and hidden easter eggs, collect powerups and points through side quests all across the city of Toronto to bring your team to the top of the leaderboard. The world is your arcade!',
      'Start Time': '6:00 PM',
      'End Time': 'Late',
      Color: 'night',
    },
  ],
  'Thursday August 28': [
    {
      'Event Name': 'Faculty Events',
      'Event Description': `More information on Faculty Events will be added soon!`,
      'Start Time': '9:00 AM',
      'End Time': '5:00 PM',
      Color: 'other',
    },
    {
      'Event Name': 'Skule™ Alumni Panel',
      'Event Description': `Power up with Skule™ Alumni Panel! Hear from U of T engineering alumni as they share their F!rosh experiences and pro tips for navigating school, PEY and their current careers. A low energy activity and a great chance to ask questions, gain insight and connect with those who’ve been in your shoes.`,
      'Start Time': '6:00 PM',
      'End Time': '7:30 PM',
      'Event Location': 'GB202',
      Color: 'general',
    },
    {
      'Event Name': 'Nitelife',
      'Event Description':
        'F!rosh Week goes dark mode with various games and activities run in the evening hours to continue the fun, offering Frosh more experiences to connect. Activities are high and low energy.',
      // 'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': 'Late',
      Color: 'night',
    },
  ],
  'Friday August 29': [
    {
      'Event Name': 'F!rosh Olympiks',
      'Start Time': '10:00 AM',
      'End Time': '5:00 PM',
      Color: 'long',
    },
    {
      'Event Name': 'Nitelife',
      'Event Description':
        'F!rosh Week goes dark mode with various games and activities run in the evening hours to continue the fun, offering Frosh more experiences to connect. Activities are high and low energy.',
      // 'Event Location': 'The Pit',
      'Start Time': '6:00 PM',
      'End Time': 'Late',
      Color: 'night',
    },
  ],
  'Saturday August 30': [
    {
      'Event Name': 'F!rosh Retreat',
      'Event Location': 'Hart House Farm',
      'Event Description':
        'F!rosh can join Leedurs for a weekend camping trip to touch grass that caps off F!rosh Week, full of swimming, campfires, games, and other fun activities to connect F!rosh.',
      'Start Time': '10:00 AM',
      'End Time': 'Late',
      Color: 'long',
    },
  ],
  'Sunday August 31': [
    {
      'Event Name': 'F!rosh Retreat',
      'Event Location': 'Hart House Farm',
      'Event Description':
        'F!rosh can join Leedurs for a weekend camping trip to touch grass that caps off F!rosh Week, full of swimming, campfires, games, and other fun activities to connect F!rosh.',
      'Start Time': 'Early',
      'End Time': '2:00 PM',
      Color: 'long',
    },
  ],
};
